import { render, staticRenderFns } from "./CopyComponents.vue?vue&type=template&id=3a2f76e6&scoped=true&"
import script from "./CopyComponents.vue?vue&type=script&lang=js&"
export * from "./CopyComponents.vue?vue&type=script&lang=js&"
import style0 from "./CopyComponents.vue?vue&type=style&index=0&id=3a2f76e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2f76e6",
  null
  
)

export default component.exports